'use es6';

import * as HubSpotFeature from 'marketplace-ui-apps-core/common/constants/groupTags/HubSpotFeature';
import * as RequestState from 'marketplace-ui-common/requestStates/RequestState';
import PropTypes from 'prop-types';
// @ts-expect-error untyped module
import StorefrontFilters from '../records/StorefrontFilters';
import * as ConnectionType from './ConnectionType';
export const hubspotFeature = PropTypes.oneOf(Object.values(HubSpotFeature));
export const storefrontFilters = PropTypes.instanceOf(StorefrontFilters);
export const requestState = PropTypes.oneOf(Object.values(RequestState));
export const connectionType = PropTypes.oneOf(Object.values(ConnectionType));

// intended to mimic the shape of ListingPricingCore from marketplace-ui-client-types until we refactor the consuming components to TS
export const ListingPricingCore = PropTypes.shape({
  amount: PropTypes.number,
  commitmentAmount: PropTypes.number,
  contactUsDetails: PropTypes.string,
  contactUsUrl: PropTypes.string,
  extraCharges: PropTypes.string,
  features: PropTypes.string,
  freeTrialDays: PropTypes.number,
  meterUnit: PropTypes.string,
  name: PropTypes.string,
  tagline: PropTypes.string,
  updatedAt: PropTypes.number,
  contactUsPlanType: PropTypes.oneOf(['MONTHLY', 'ONE_TIME', 'YEARLY']),
  planType: PropTypes.oneOf(['CONTACT_US', 'FREE', 'METERED', 'MONTHLY', 'ONE_TIME', 'YEARLY'])
}).isRequired;